<template>
  <v-card class="search-nsr">
    <v-card-title class="justify-center">NSR Item Search</v-card-title>
    <v-card-text class="d-flex flex-column flex-grow-1 overflow-y-auto">
      <v-row class="flex-grow-0 pt-4">
        <v-col cols="3">
          <v-text-field
            outlined
            clearable
            hide-details
            label="Item No."
            v-model="itemNo"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            outlined
            clearable
            hide-details
            label="Search"
            v-model="keyword"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-select
            outlined
            clearable
            hide-details
            label="Unit"
            :items="unitIdOptions"
            v-model="selectedUnitId"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="flex-grow-0">
        <v-col>
          <v-btn class="mr-4" color="primary" @click="search">Search </v-btn>
        </v-col>
      </v-row>
      <v-row class="flex-grow-0">
        <v-col>
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row class="flex-grow-1">
        <NsrItemSearchList
          full-height
          @add="$emit('submit', $event)"
          :work-order="workOrder"
          :extra-filters="searchFilter"
        ></NsrItemSearchList>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import ItemSearchList from "@/components/sor/ItemSearchList";
import NsrItemSearchList from "@/components/nsr/NsrItemSearchList";

export default {
  name: "SearchNsrDialog",
  components: { NsrItemSearchList, ItemSearchList },
  props: {
    workOrder: Object,
    showAdd: Boolean,
  },
  setup(props, { root, emit }) {
    const itemNo = ref(null);
    const keyword = ref(null);

    const unitIdOptions = ref([
      { text: "M3", value: "A" },
      { text: "M2", value: "B" },
      { text: "M", value: "C" },
      { text: "KG", value: "D" },
      { text: "ITEM", value: "E" },
    ]);
    const selectedUnitId = ref(null);

    const currentSearchFilter = computed(() => {
      const filter = {};

      if (itemNo.value) {
        filter["item_no"] = { search: true, value: itemNo.value };
      }

      if (keyword.value) {
        filter["action_description"] = {
          search: true,
          value: keyword.value.split(" "),
        };
      }

      if (selectedUnitId.value) {
        filter["unit_id"] = { exact: true, value: selectedUnitId.value };
      }

      return filter;
    });
    const searchFilter = ref(null);
    const search = function () {
      searchFilter.value = { ...currentSearchFilter.value };
    };

    return {
      itemNo,
      keyword,
      unitIdOptions,
      selectedUnitId,

      currentSearchFilter,
      searchFilter,
      search,
    };
  },
};
</script>

<style lang="less">
.search-nsr {
  display: flex;
  flex-direction: column;
  height: 90vh;
}
</style>
